/* global angular */

var moment = require('moment')
require('highcharts/modules/exporting.js')

angular.module('AemCspsFundsActual')
  .component('fundActual', {
    template: require('./fund-actual.component.tpl.html'),
    controller: FundActualCtrl,
    controllerAs: 'vm'
  })

FundActualCtrl.$inject = ['wgService', 'appLoader', 'pensionService', '$filter']

function FundActualCtrl (wgService, appLoader, pensionService, $filter) {
  var vm = this
  vm.isErrorBackend = false

  vm.$onInit = function () {
    vm.fundId = wgService.getParams().fundId || 'dps1'

    vm.fundData = []
    vm.fundList = []

    vm.toDate = moment(new Date()).startOf('day').toDate()
    var from = moment(vm.toDate).subtract(14, 'days').startOf('day').toDate()
    getData(from, vm.toDate)
  }

  function getData (from, to) {
    var params = {
      from: from && moment(from).format('YYYY-MM-DD'),
      to: to && moment(to).format('YYYY-MM-DD')
    }
    appLoader.show()
    pensionService.fundHistory(vm.fundId, params)
      .then(function (response) {
        vm.fullData = response.data
        vm.fullData = vm.fullData.reverse()

        vm.fundData = []
        for (var i = 0, len = response.data.length; i < len; i++) {
          vm.fundData.push({
            x: moment(response.data[i].date).valueOf(),
            y: response.data[i].valorizationPercentage
          })
        }
        vm.fundData.sort(function (a, b) {
          return a.x - b.x
        })
        if (vm.fullData[0] !== undefined) {
          vm.fundList = vm.fullData[0]
        }
      })
      .catch(function () {
        vm.isErrorBackend = true
      })
      .finally(function () {
        appLoader.hide()
      })
  }
}
